import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { useContent } from "@/hooks/useContent";

const PlaylistSection = () => {
  const { data: site } = useContent("/content/site.json");
  if (!site) return null;

  return (
    <section data-testid="playlist-section" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 sm:pb-28">
      <SectionHeading
        chapter="03.5 // Playlist completa"
        title="No repeat, direto do SoundCloud"
        note="A coletânea oficial da Clássicos do Funk, atualizada pelo próprio DJ."
      />
      <Reveal className="border border-[#232638] bg-[#10121A] p-3 sm:p-4">
        <iframe
          title="Playlist Clássicos do Funk no SoundCloud"
          data-testid="soundcloud-playlist-iframe"
          width="100%"
          height="450"
          scrolling="no"
          frameBorder="no"
          allow="autoplay"
          src={site.soundcloudPlaylist}
        />
      </Reveal>
    </section>
  );
};

export default PlaylistSection;
